import { BASE_URL } from '../components/AppConfig';

const getAuthToken = () => {
  const sessionToken = sessionStorage.getItem('sessionToken');
  return sessionToken ? `Bearer ${sessionToken}` : '';
};

const authFetch = async (path, options = {}) => {
  const token = getAuthToken();
  if (!token) {
    return { statusCode: '50000', message: 'Not authenticated' };
  }

  try {
    const response = await fetch(`${BASE_URL}${path}`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        ...(options.headers || {}),
      },
      ...options,
    });

    return response.json().catch(() => ({}));
  } catch {
    return { statusCode: '50000', message: 'Request failed' };
  }
};

export const isReportsApiSuccess = (res) =>
  String(res?.statusCode || '') === '10000' || res?.statusCode == null;

export const getReportsApiPayload = (res) => res?.data ?? null;

const buildQuery = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.set(key, String(value));
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
};

/** GET /admin/reports/users/search */
export const searchReportUsers = ({ q, limit = 20, offset = 0 } = {}) =>
  authFetch(`/admin/reports/users/search${buildQuery({ q, limit, offset })}`, {
    method: 'GET',
  });

/** GET /admin/reports/users */
export const listReportedUsers = ({ status = 'pending', q, limit = 20, offset = 0 } = {}) =>
  authFetch(`/admin/reports/users${buildQuery({ status, q, limit, offset })}`, {
    method: 'GET',
  });

/** POST /admin/reports/users/:userId/disable */
export const disableReportUser = (userId, body = {}) =>
  authFetch(`/admin/reports/users/${encodeURIComponent(userId)}/disable`, {
    method: 'POST',
    body: JSON.stringify(body),
  });

/** POST /admin/reports/users/:userId/enable */
export const enableReportUser = (userId, body = {}) =>
  authFetch(`/admin/reports/users/${encodeURIComponent(userId)}/enable`, {
    method: 'POST',
    body: JSON.stringify(body),
  });

/** GET /admin/reports/posts */
export const listReportedPosts = ({ status = 'pending', q, limit = 20, offset = 0 } = {}) =>
  authFetch(`/admin/reports/posts${buildQuery({ status, q, limit, offset })}`, {
    method: 'GET',
  });

/** POST /admin/reports/posts/:feedId/delete */
export const deleteReportedPost = (feedId, body = {}) =>
  authFetch(`/admin/reports/posts/${encodeURIComponent(feedId)}/delete`, {
    method: 'POST',
    body: JSON.stringify(body),
  });

/** POST /admin/reports/:reportId/dismiss */
export const dismissReport = (reportId, body = {}) =>
  authFetch(`/admin/reports/${encodeURIComponent(reportId)}/dismiss`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
